import { textAlignmentType } from '../../components/molecules/CardTypes/types'

export const alignment = (alignmentType: textAlignmentType) => {
  switch (alignmentType?.toLowerCase()) {
    case 'center':
      return 'text-center'
    case 'right':
      return 'text-right'
    case 'left':
      return 'text-left'
    default:
      return ''
  }
}
